var map = {
	"./Autoristan.png": 9222,
	"./Bricologia.png": 637,
	"./Eurocorp.png": 363,
	"./Neo Atlas.png": 1709,
	"./Petrolistan.png": 5505,
	"./Sudica.png": 7981,
	"./Volgovie.png": 2815,
	"./Zhongo.png": 9419
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3535;